import { apiAsync } from '../../../common/helpers'

const getPrimaryFormat = async () => {
  const planogramFormat = await JSON.parse(global.sessionStorage.getItem('company')).planogramFormat

  if (!planogramFormat) return 'AOO'

  return planogramFormat
}

export const getPostersData = async () => {
  return apiAsync({
    api: 'items/displayPdfs',
    params: { format: await getPrimaryFormat() }
  })
}

// TODO: We really should be calling get-location-counts instead. See ELC-1664 - Will 11/30/2023
export const queryLocations = async () => {
  const companyId = JSON.parse(global.sessionStorage.getItem('company'))._id

  const params = {
    products: 'postings',
    pageSize: 1, // we don't actually need any locations just the facet for country~state
    pageNumber: 1,
    includeLocaleFacets: true
  }

  return apiAsync({
    api: `external/companies/${companyId}/locations`,
    params,
    method: 'GET'
  })
}
